/*
  Ported from src/components/Hero.tsx + src/components/WindParticles.tsx.
  Runs once per <oblivion-hero> section instance. Depends on gsap.min.js,
  gsap-scrolltrigger.min.js (both loaded globally in theme.liquid) and
  split-type.min.js (loaded by oblivion-hero.liquid itself, homepage-only).
*/
(function () {
  function initHero(root) {
    if (typeof window.gsap === 'undefined' || typeof window.SplitType === 'undefined') return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var line1 = root.querySelector('[data-hero-line="1"]');
    var line2 = root.querySelector('[data-hero-line="2"]');

    var split1 = new window.SplitType(line1, { types: 'chars' });
    var split2 = new window.SplitType(line2, { types: 'chars' });
    var chars = [].concat(split1.chars || [], split2.chars || []);

    gsap.set(chars, { y: prefersReduced ? 0 : 110, opacity: prefersReduced ? 1 : 0 });

    gsap
      .timeline({ delay: 0.15 })
      .to(chars, { y: 0, opacity: 1, duration: 1.1, stagger: 0.035, ease: 'power4.out' })
      .fromTo(
        root.querySelector('.oblivion-hero__sub'),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' },
        '-=0.5'
      )
      .fromTo(
        root.querySelector('.oblivion-hero__cta'),
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' },
        '-=0.55'
      )
      .fromTo(
        root.querySelector('.oblivion-hero__scroll-cue'),
        { opacity: 0 },
        { opacity: 1, duration: 0.6 },
        '-=0.3'
      );

    initWindParticles(root, ScrollTrigger, gsap);
  }

  function initWindParticles(root, ScrollTrigger, gsap) {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var canvas = root.querySelector('[data-hero-wind-canvas]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var isCoarse = window.matchMedia('(hover: none)').matches;
    var width = (canvas.width = window.innerWidth);
    var height = (canvas.height = window.innerHeight);
    var turbulence = { current: 1 };

    var count = isCoarse ? 45 : 110;
    var particles = Array.from({ length: count }, function () {
      return {
        x: Math.random() * width,
        y: Math.random() * height,
        len: 40 + Math.random() * 120,
        speed: 4 + Math.random() * 10,
        opacity: 0.08 + Math.random() * 0.18,
      };
    });

    function onResize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }
    window.addEventListener('resize', onResize);

    var raf;
    function render() {
      ctx.clearRect(0, 0, width, height);
      var t = turbulence.current;
      ctx.strokeStyle = 'rgba(244,244,240,1)';
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x -= p.speed * (0.3 + t);
        if (p.x < -p.len) {
          p.x = width + p.len;
          p.y = Math.random() * height;
        }
        ctx.globalAlpha = p.opacity * t;
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        ctx.lineTo(p.x + p.len * (0.4 + t * 0.6), p.y + t * 6);
        ctx.lineWidth = 1;
        ctx.stroke();
      }
      raf = requestAnimationFrame(render);
    }
    raf = requestAnimationFrame(render);

    if (ScrollTrigger) {
      ScrollTrigger.create({
        trigger: root,
        start: 'top top',
        end: '+=60%',
        scrub: true,
        onUpdate: function (self) {
          gsap.to(turbulence, { current: 1 - self.progress, duration: 0.3, overwrite: true });
        },
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
